var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_121_1185)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24.0005,
    r: 24,
    fill: "url(#paint0_linear_121_1185)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24.0005,
    r: 23.6167,
    stroke: "url(#paint1_radial_121_1185)",
    strokeWidth: 0.766667
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24.0005,
    r: 23.6167,
    stroke: "url(#paint2_radial_121_1185)",
    strokeWidth: 0.766667
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 17C16 15.8954 16.8954 15 18 15H21.2792C21.7097 15 22.0918 15.2754 22.2279 15.6838L23.7257 20.1772C23.8831 20.6493 23.6694 21.1653 23.2243 21.3879L20.967 22.5165C22.0692 24.9612 24.0388 26.9308 26.4835 28.033L27.6121 25.7757C27.8347 25.3306 28.3507 25.1169 28.8228 25.2743L33.3162 26.7721C33.7246 26.9082 34 27.2903 34 27.7208V31C34 32.1046 33.1046 33 32 33H31C22.7157 33 16 26.2843 16 18V17Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_121_1185",
    x: -8.80029,
    y: -8.79981,
    width: 65.6006,
    height: 65.6006,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.40015
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_121_1185"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_121_1185",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_121_1185",
    x1: -198.222,
    y1: -32.1995,
    x2: 22.3786,
    y2: 127.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_121_1185",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.1991 46.2438) rotate(-140.546) scale(63.2869 43.4196)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353C46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_121_1185",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-22.1333 -10.5995) rotate(26.5462) scale(60.4136 51.7265)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.9299b1932a69be5ed660c1f61c361be9.svg";
export { ForwardRef as ReactComponent };